import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F0F0F0",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "m6.781 16.173 1.044 7.08c1.3.482 2.706.746 4.174.746 5.16 0 9.558-3.256 11.253-7.826z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#6DA544",
  d: "M6.781 7.827 7.825.747C9.125.264 10.53 0 11.999 0c5.16 0 9.558 3.257 11.253 7.827z"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#A2001D",
  d: "M0 12c0 5.16 3.257 9.558 7.826 11.254V.746C3.256 2.442 0 6.84 0 12"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }